<template>
  <div v-if="loading" class="d-flex justify-center align-center" :style="{ height: height }">
    <v-progress-circular indeterminate color="primary" size="32" width="5"></v-progress-circular>
  </div>
  <div v-else-if="data.length">
    <span v-if="label" style="font-size:12px; font-weight:700; color:#000;">{{ label }}</span>
    <VerticalBarChart :chart-data="chartData" :options="chartOptions" :style="{ height: height }" />
  </div>
</template>

<script>
import VerticalBarChart from '../Reports/Charts/Canvas/VerticalBarChart'
import { DateTime } from 'luxon'

const LOW_OCCUPANCY_THRESHOLD = 3
const MEDIUM_OCCUPANCY_THRESHOLD = 5
const HIGH_OCCUPANCY_THRESHOLD = 8

const chartOptions = {
  maintainAspectRatio: false,
  legend: { display: false },
  scales: {
    yAxes: [
      {
        ticks: { min: 0, stepSize: 1 },
        scaleLabel: { display: true, labelString: 'Ilość pojazdów' }
      }
    ],
    xAxes: [
      {
        gridLines: { display: false },
        scaleLabel: { display: true }
      }
    ]
  }
}

function getBarColor(value) {
  if (value < LOW_OCCUPANCY_THRESHOLD) return '#22c55e' // green
  if (value < MEDIUM_OCCUPANCY_THRESHOLD) return '#eab308' // yellow
  if (value < HIGH_OCCUPANCY_THRESHOLD) return '#ef4444' // red
  return '#000000' // black
}

export default {
  components: {
    VerticalBarChart
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '200px'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chartOptions
    }
  },
  computed: {
    chartData() {
      return {
        labels: this.data.map(s => DateTime.fromISO(s.timestamp).toFormat('HH:mm')),
        datasets: [
          {
            label: 'Obłożenie placu',
            data: this.data.map(s => s.numVehicles),
            backgroundColor: this.data.map(s => getBarColor(s.numVehicles)),
            maxBarThickness: 50
          }
        ]
      }
    }
  }
}
</script>
